var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mark',{style:({ backgroundColor: _vm.color }),attrs:{"data-label":_vm.label},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }